module.exports = __webpack_public_path__ + "img/icon-lock-muted-secure.077f77ce.svg";